
import { utils as parentUtils } from '@/app-template/lib/composables/utils';

export function utils() {
  return {
    ...parentUtils(),
  };
}